import { useContext } from 'react';
import { ThemeContext } from './themeContext';
import type { UseThemeResult } from './useTheme';

/**
 * Access the shared theme state (mode, resolved theme, setMode, cycleMode).
 *
 * Throws when used outside {@link ThemeProvider} so mis-wiring fails loudly.
 */
export function useThemeContext(): UseThemeResult {
  const value = useContext(ThemeContext);
  if (value === undefined) {
    throw new Error('useThemeContext must be used within a ThemeProvider');
  }
  return value;
}
